// context/TipoEspacioContext.js
import React, { createContext, useState, useContext } from 'react';

const   CategoryContext = createContext();

export const useCategoriaServicio = () => {
  return useContext(CategoryContext);
};

export const CategoriaServicio = ({ children }) => {
const [categoriaSeleccionado, setCategoriaSeleccionado] = useState(null);

  return (
<CategoryContext.Provider value={{ categoriaSeleccionado, setCategoriaSeleccionado }}>
      {children}
    </CategoryContext.Provider>
  );
};
